var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "selectRef",
      staticClass: "dropdown-selector",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _setup.toggle.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dropdown-selector__label",
          class: { _open: _setup.isLabelActive },
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-selector__value" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _setup.inputValue,
              expression: "inputValue",
            },
          ],
          staticClass: "dropdown-selector__input",
          attrs: { type: "text", placeholder: _vm.placeholder },
          domProps: { value: _setup.inputValue },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return _setup.select(_setup.filteredOptions[0])
            },
            input: function ($event) {
              if ($event.target.composing) return
              _setup.inputValue = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(_setup.vDown, {
        staticClass: "vicon-black dropdown-selector__arrow",
        class: { _open: _setup.isOpened },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _setup.toggle.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _setup.isOpened
        ? _c(
            "div",
            {
              staticClass: "dropdown-selector__menu",
              class: { _open: _setup.isOpened },
            },
            _vm._l(_setup.filteredOptions, function (option) {
              return _c(
                "div",
                {
                  key: option.id,
                  staticClass: "dropdown-selector__option",
                  class: {
                    _selected: _setup.isMultiple
                      ? _setup.normalizedChoosed.includes(String(option.id))
                      : _setup.normalizedChoosed === String(option.id),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _setup.select(option)
                    },
                  },
                },
                [
                  _setup.isMultiple
                    ? _c(
                        "svg",
                        {
                          staticClass: "checkbox__check",
                          attrs: {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "20 6 9 17 4 12" },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "dropdown-selector__option-name" },
                    [_vm._v(_vm._s(option.name))]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }